export const imageExtensions = [".png", ".jpg", ".jpeg"] as const;
export const imageMimeTypes = ["image/png", "image/jpeg"] as const;

export type DocumentKind = "image" | "pdf" | "other";

const pdfExtension = ".pdf";

export const documentKindFromName = (fileName: string | null | undefined): DocumentKind => {
  if (!fileName) return "other";
  const lower = fileName.toLowerCase();
  if (imageExtensions.some((ext) => lower.endsWith(ext))) return "image";
  if (lower.endsWith(pdfExtension)) return "pdf";
  return "other";
};
